// components/leads/LeadListView.js
// Vista lista dei lead

import React from 'react';
import { User } from 'lucide-react';

const LeadListView = ({ filteredLeads, LeadCardComponent }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4" data-testid="leads-list-view">
      {filteredLeads.length === 0 ? (
        <div className="col-span-full text-center py-12 text-[#737373]">
          <User className="w-12 h-12 mx-auto mb-4 text-gray-300" />
          <p>Nessun lead trovato</p>
        </div>
      ) : (
        filteredLeads.map(lead => (
          <LeadCardComponent key={lead.id} lead={lead} />
        ))
      )}
    </div>
  );
};

export default LeadListView;
